// extracted by mini-css-extract-plugin
export var spinner = "spinner-module--spinner--cyGLv";
export var spinnerGif = "spinner-module--spinner-gif--Oi568";